var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading)?_c('portal-announcements-skelton-loader'):_c('portal-announcements-panel',{attrs:{"user-announcements":_vm.userAnnouncements},on:{"button-link-opened":_vm.buttonLinkOpened}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }